import { fillRectWithValue, rectFitsWithGap } from '../tile-grid';
import type { GenerateFillLayoutOptions, TileLayoutResult } from '../tile-layout-types';

import type { FillLayoutContext } from './fill-layout-context';
import { createFillLayoutContext, topUpAndFinalize } from './fill-layout-context';

/** Axis-aligned strips with open-gap spacing; tops up with scatter afterward. */
export function generateAxisAlignedGappedStripsLayout(options: GenerateFillLayoutOptions): TileLayoutResult {
  const ctx = createFillLayoutContext(options);
  const primaryFilled = placeAxisAlignedGappedStrips(ctx);
  return topUpAndFinalize(ctx, 'axisAlignedGappedStrips', primaryFilled);
}

export function placeAxisAlignedGappedStrips(ctx: FillLayoutContext): number {
  const { grid, width, height, budget, gapTiles, minPlacementSizeTiles, maxPlacementSizeTiles, fillTileValue, rand } = ctx;
  const stripCount = Math.max(8, Math.floor((width * height * ctx.coverageCap) / 24));
  let placed = 0;
  let attempts = 0;
  let filled = 0;

  while (placed < stripCount && attempts < stripCount * 40) {
    attempts++;
    const horizontal = rand() > 0.5;

    for (let length = maxPlacementSizeTiles; length >= minPlacementSizeTiles; length--) {
      const wTiles = horizontal ? length : 1;
      const hTiles = horizontal ? 1 : length;
      const col = 1 + Math.floor(rand() * Math.max(1, width - wTiles - 2));
      const row = 1 + Math.floor(rand() * Math.max(1, height - hTiles - 2));

      const rect = { x: col, y: row, width: wTiles, height: hTiles };
      if (!rectFitsWithGap(grid, width, height, rect, gapTiles, fillTileValue)) {
        continue;
      }

      const added = fillRectWithValue(grid, width, height, rect, budget, fillTileValue);
      if (added > 0) {
        filled += added;
        placed++;
        break;
      }
    }
  }

  return filled;
}
